export default __webpack_public_path__ + "static/media/blizz-casino-logo-gradient.f1beca22.svg";